import React, { createContext, useState, useEffect } from "react";

// Kontext erstellen
export const NameContext = createContext();

export const NameProvider = ({ children }) => {
  // ⬇️ Lade-Zustand für initiale Reads
  const [isLoading, setIsLoading] = useState(true);

  // ⬇️ Start mit leeren States, Werte kommen im useEffect!
  const [name, setName] = useState("");
  const [isNameEntered, setIsNameEntered] = useState(false);
  const [showAlternateMessage, setShowAlternateMessage] = useState(false);
  const [nameColor, setNameColor] = useState("#ec4899");
  const [showFormDirectly, setShowFormDirectly] = useState(false);

  // Initial: Werte aus localStorage holen
  useEffect(() => {
    const storedName = localStorage.getItem("userName");
    setName(storedName || "...");
    // Neuer User (kein localStorage) → automatisch eingeloggt mit "Unbekannt"
    setIsNameEntered(storedName !== null ? localStorage.getItem("isNameEntered") === "true" : true);
    setNameColor(localStorage.getItem("nameColor") || "#ec4899");
    setIsLoading(false);
  }, []);

  // Nach Änderungen: Werte speichern
  useEffect(() => {
    if (!isLoading) localStorage.setItem("userName", name);
  }, [name, isLoading]);

  useEffect(() => {
    if (!isLoading) localStorage.setItem("isNameEntered", isNameEntered);
  }, [isNameEntered, isLoading]);

  useEffect(() => {
    if (!isLoading) localStorage.setItem("nameColor", nameColor);
  }, [nameColor, isLoading]);

  const forceNameEntry = () => setIsNameEntered(false);
  const showNameForm = (callback) => {
    setShowFormDirectly(true);
    if (callback) callback();
  };
  const closeNameForm = () => setShowFormDirectly(false);
  const handleNoThanks = () => {
    setName("Demo");
    setIsNameEntered(true);
  };

  return (
    <NameContext.Provider
      value={{
        name,
        setName,
        isNameEntered,
        setIsNameEntered,
        showAlternateMessage,
        setShowAlternateMessage,
        nameColor,
        setNameColor,
        showFormDirectly,
        setShowFormDirectly,
        forceNameEntry,
        showNameForm,
        closeNameForm,
        handleNoThanks,
        isLoading, // <-- NEU: Context liefert Lade-Status!
      }}
    >
        {!isLoading && children}
    </NameContext.Provider>
  );
};
